import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import "./index.scss";
const dropdownOptions = [
  { label: "Request Submitted", value: 1 },
  { label: "Accepted", value: 2 },
  { label: "Rejected", value: 3 },
  { label: "Revoked", value: 4 },
];
const Dropdown = ({ position, selected, onSelect, dropdownRef }) => {
  return createPortal(
    <div className="custom-filter-dropdown" ref={dropdownRef} style={position}>
      {dropdownOptions.map((option) => (
        <label key={option.value} className="filter-checkbox">
          <input
            type="checkbox"
            checked={selected.includes(option.value)}
            onChange={(e) => {
              e.stopPropagation(); // Prevent the dropdown from closing
              onSelect(option.value);
            }}
            className="terms-checkbox"
          />
          {option.label}
        </label>
      ))}
    </div>,
    document.body,
  );
};
const RequestStatusFilterHeader = ({
  displayName,
  onFilterChange,
  currentFilters,
}) => {
  const iconRef = useRef(null);
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const getInitialStatuses = () => {
    if (!currentFilters || currentFilters.length === 0) return [];
    return currentFilters.map((f) => Number(f.split(":")[1]));
  };
  const [selectedStatuses, setSelectedStatuses] = useState(getInitialStatuses);
  const [dropdownPosition, setDropdownPosition] = useState({});
  const toggleDropdown = () => {
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      setDropdownPosition({
        position: "absolute",
        top: rect.bottom + window.scrollY + 5,
        left: rect.left + window.scrollX,
        zIndex: 1000,
      });
    }
    setShowDropdown((prev) => !prev);
  };
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        showDropdown &&
        iconRef.current &&
        !iconRef.current.contains(e.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown]);
  const isInitialMount = useRef(true);
  const handleStatusSelect = (status) => {
    setSelectedStatuses((prevSelected) => {
      const updated = prevSelected.includes(status)
        ? prevSelected.filter((s) => s !== status)
        : [...prevSelected, status];
      // Immediately close dropdown after selecting/deselecting
      setShowDropdown(false);
      return updated;
    });
  };
  useEffect(() => {
    // Skip firing onFilterChange on initial mount to avoid resetting
    // the parent's filters when AG Grid re-mounts this header component
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    let filterQuery = null;
    if (selectedStatuses.length > 0) {
      filterQuery = selectedStatuses
        .map((status) => `request_status:${status}`)
        .join(",");
    }
    onFilterChange(filterQuery);
  }, [selectedStatuses]);
  return (
    <div className="custom-filter-header" ref={iconRef}>
      <span className="custom-filter-header-label">{displayName}</span>
      <FontAwesomeIcon
        icon={faFilter}
        onClick={toggleDropdown}
        className="filter-icon"
      />
      {showDropdown && (
        <Dropdown
          position={dropdownPosition}
          selected={selectedStatuses}
          onSelect={handleStatusSelect}
          dropdownRef={dropdownRef}
        />
      )}
    </div>
  );
};
export default RequestStatusFilterHeader;
